import { isEcoFoot2Plus, isRM10Evolution, isRM5, isRmGridflex10D, isRmGridflex5Rwdi } from "__common/constants/products";
import { MAX_BLOCK_COUNTS, interiorBayCapacity, rm5MaxBlockCount, rmGridflex10MaxBlockCount } from "../utils/constants";

export const apiField = 'min_block_count';

interface MinBlockCountField {
  type: string;
  apiField: string;
  missing?: any;
  label: string;
  tooltip: () => string;
  data?: MinBlockCountFieldOption[];
  min: number;
  max: number;
  step?: number;
}

interface MinBlockCountFieldOption {
  value: string;
  name: string;
}

function makeConfig(max: number = 8, step: number = 1, min: number = 0, ): MinBlockCountField {  
  return {
    type: 'Number',
    label : "minBlockCount",
    apiField,
    tooltip: undefined,
    min,
    max,
    missing:undefined,
    step,
  };
}

export const getMinBlockCountField = (productId, max_blocks, interior_bay_capacity, half_block_allowed?, fully_attached?, orientation?) => {
  let maxBlockCountOfProducts;
  let upperLimit;
  let maxInteriorCapacityOfProducts;
  let stepIncrement = half_block_allowed ? 0.5 : 1;
  let maxLimit = interior_bay_capacity ? ((max_blocks > interior_bay_capacity) ? interior_bay_capacity : max_blocks): max_blocks;
  if(isRM10Evolution(productId) || isEcoFoot2Plus(productId)){
    maxBlockCountOfProducts = MAX_BLOCK_COUNTS[productId]
  }
  else if(isRM5(productId)){
    maxBlockCountOfProducts = rm5MaxBlockCount(half_block_allowed)
  }
  else if(isRmGridflex10D(productId)){
      maxBlockCountOfProducts = rmGridflex10MaxBlockCount(half_block_allowed, orientation)
    }
  else if(isRmGridflex5Rwdi(productId)){
      maxBlockCountOfProducts = 5;
    }

  if(interior_bay_capacity){
    maxInteriorCapacityOfProducts = interiorBayCapacity(productId, half_block_allowed)
  }

  if (maxLimit != 0){
    upperLimit = maxLimit-stepIncrement
  }
  else{
    upperLimit = maxLimit
  }
  if(maxLimit > (interior_bay_capacity ? maxInteriorCapacityOfProducts : maxBlockCountOfProducts)){
    upperLimit = (interior_bay_capacity ? maxInteriorCapacityOfProducts : maxBlockCountOfProducts)-stepIncrement
    stepIncrement = 0
  }
  return makeConfig(upperLimit, stepIncrement);
};


